import React from 'react';
import { Button, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faEye, faPencil, faPlus } from '@fortawesome/free-solid-svg-icons';
import { formatDateTime } from '../../utils/date'; 
import { EntityFormLayoutProps } from '../../types/formLayout.types';

export const EntityFormLayout = ({
  title,
  mode,
  data,
  loading,
  dirty,
  onGoBack,
  onReset,
  onDelete,
  onCreateNew,
  onEdit,
  onView,
  children,
}: EntityFormLayoutProps) => {
  const isView = mode === 'view';
  const isEdit = mode === 'edit';
  const isCreate = mode === 'create';  
  const getUserLabel = (user?: { fullName: string; email: string }) =>
    user?.fullName ? (
      <span title={user.email}>{user.fullName}</span>
    ) : (
      '-'
    );

  return (
    <div className="p-6 bg-white rounded-lg shadow-sm h-full flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center border-b pb-4 mb-6">
        <div className="flex items-center gap-3">
          <FontAwesomeIcon
            icon={faChevronLeft}
            className="text-gray-600 hover:text-black text-xl cursor-pointer"
            onClick={onGoBack}
          />
          <h1 className="text-2xl font-semibold text-gray-800 m-0">{title}</h1>
        </div>

        {(isView || isEdit) && (
          <div className="flex gap-2">

            {isEdit && onEdit && (
              <Button
                title="View"
                icon={<FontAwesomeIcon icon={faEye} />}
                shape="circle"
                onClick={onView}
                className="shadow" />
            )}
            {isView && onView && (
              <Button
                title="Edit"
                icon={<FontAwesomeIcon icon={faPencil} />}
                shape="circle"
                onClick={onEdit}
                className="shadow" />
            )}
            {onCreateNew && (
              <Button
                title="Create New"
                shape="circle"
                icon={<FontAwesomeIcon icon={faPlus} />}
                onClick={onCreateNew}
              />
            )}
            {onDelete && (
              <Popconfirm title="Are you sure to delete this?" onConfirm={onDelete}>
                <Button
                  title="Delete"
                  shape="circle"
                  icon={<DeleteOutlined />}
                  danger
                  className="shadow"
                />
              </Popconfirm>
            )}
          </div>
        )}
      </div>

      {/* Scrollable Body */}
      <div className="flex-grow overflow-y-auto overflow-x-hidden px-2">{children}</div>

      {/* Footer */}
      <div className="pt-4 mt-4 border-t bg-white sticky bottom-0 z-10">
        <div className="flex justify-between items-center">
          <div className="text-xs text-gray-500 leading-snug space-y-0.5 min-w-[220px]">
            {!isCreate && data?.createdBy && (
              <div>
                Created: {formatDateTime(data.createdAt)} by {getUserLabel(data.createdBy)}
              </div>
            )}
            {!isCreate && data?.updatedBy && (
              <div>
                Updated: {formatDateTime(data.updatedAt)} by {getUserLabel(data.updatedBy)}
              </div>
            )}
          </div>
          {!isView && (
            <div className="flex gap-2">
              <Button type="primary" htmlType="submit" loading={loading} disabled={!dirty}>
                Save
              </Button>
              <Button htmlType="reset" onClick={onReset} disabled={!dirty}>
                Reset
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
